<template>
    <div class="EntryListItem border-bottom"
         :draggable="!isBusy"
         @dragstart="onDrag($event)"
         @dragend="onDragEnd($event)"
    >
        <b-overlay
            class="d-flex pb-2 pt-2"
            :show="isBusy"
            rounded="lg"
            opacity="0.6"
            spinner-variant="primary"
            spinner-small spinner-type="grow">
            <mq-layout mq="md+">
                <div class="block">
                    <a v-bind:href="entry.url" target="_blank" rel="noopener">
                        {{ truncate(displayTitle, 64, '...') }}
                    </a>
                    <span class="d-block color-undertone">
                        <small>
                            {{ truncate(entry.url, 82, '...') }}
                        </small>
                    </span>
                </div>
            </mq-layout>

            <mq-layout :mq="['xs', 'sm']">
                <a v-bind:href="entry.url" rel="noopener">
                    <span>
                        {{ truncate(displayTitle, 32, '...') }}
                    </span>
                </a>
            </mq-layout>

            <div class="ml-auto">
                <button-dropdown icon="ellipsis-h">

                    <button-dropdown-item
                        text="View QR Code"
                        @click="entryService.send({ type: 'SHOW_QR_OVERLAY' })"
                    />

                    <button-dropdown-item
                        text="Refresh Title"
                        @click="entryService.send({ type: 'REFRESH_TITLE' })" />

                    <button-dropdown-item
                        text="Rename"
                        @click="entryService.send({ type: 'INTENT_RENAME' })" />

                    <button-dropdown-item
                        text="Archive"
                        v-if="entry.is_archived === false"
                        @click="entryService.send({ type: 'TOGGLE_ARCHIVE', value: true })"
                    />

                    <button-dropdown-item
                        text="Restore"
                        v-if="entry.is_archived === true"
                        @click="entryService.send({ type: 'TOGGLE_ARCHIVE', value: false })"
                    />

                    <div class="dropdown-divider"></div>

                    <button-dropdown-item
                        text="Delete"
                        @click="entryService.send('DELETE')"
                    />
                </button-dropdown>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import helpers from "resources/js/helpers/index.js";

export default {
    name: "EntryListItem",
    props: ["entry", "entryRef"],
    mixins: [helpers],
    created() {
        this.entryService
            .onTransition((state) => {
                this.currentState = state;
                this.context = state.context;
            })
            .start();
    },
    data() {
        return {
            entryService: this.entryRef,
            currentState: this.entryRef.initialState,
            context: this.entryRef.context,
        };
    },
    computed: {
        displayTitle: function () {
            let title = this.entry.url;
            const metaCollection = collect(this.entry.meta);
            const titleMeta = metaCollection.firstWhere('type', 'title');
            const customTitleMeta = metaCollection.firstWhere('type', 'custom_title');
            if (this.hasLength(customTitleMeta?.value)) {
                title = customTitleMeta.value;
            } else if (this.hasLength(titleMeta?.value)) {
                title = titleMeta.value;
            }
            return title;
        },
        isBusy() {
            return this.currentState.matches('busy');
        }
    },
    methods: {
        onDrag(evt) {
            this.isDragging = true;
            evt.dataTransfer.dropEffect = 'move';
            evt.dataTransfer.effectAllowed = 'move';
            evt.dataTransfer.setData('entryId', this.entry.id);
            evt.dataTransfer.setData('sourceType', 'entry');
        },

        hasLength(string) {
            return string?.trim()?.length;
        },

        onDragEnd(evt) {
            this.isDragging = false;
        },
    },
}
</script>
